import * as React from 'react';

import { SelectorKey } from 'shared/newEntities/components/Selector';
import VirtualizedList from 'shared/newComponents/VirtualizedList';
import {
  VIRTUAL_LIST_DEFAULT_MAX_HEIGHT,
  VIRTUAL_LIST_VIRTUOSO_MIN_COUNT
} from 'shared/newEntities/components/VirtualizedList';

type Props = {
  optionKeys: SelectorKey[];
  withVirtuoso: boolean;
  listResetKey?: string | number;
  itemContent: (index: number) => React.ReactNode;
};

const OptionsList: React.FC<Props> = ({
  optionKeys,
  withVirtuoso,
  listResetKey,
  itemContent
}) => {
  if (!withVirtuoso) {
    return (
      <>
        {optionKeys.map((optionKey, index) => (
          <React.Fragment key={optionKey}>{itemContent(index)}</React.Fragment>
        ))}
      </>
    );
  }

  return (
    <VirtualizedList
      itemCount={optionKeys.length}
      virtuosoMinCount={VIRTUAL_LIST_VIRTUOSO_MIN_COUNT}
      maxHeight={VIRTUAL_LIST_DEFAULT_MAX_HEIGHT}
      listResetKey={listResetKey}
      itemContent={itemContent}
    />
  );
};

export default React.memo(OptionsList);
